export const PPARK1933_DESKTOP_ITERATION = 'PPARK1933_DESKTOP_ITERATION';
